import { render, staticRenderFns } from "./TLDnew.vue?vue&type=template&id=77060fb1&lang=pug&"
import script from "./TLDnew.vue?vue&type=script&lang=js&"
export * from "./TLDnew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports